import React from "react";
import SectionTitle from "../components/SectionTitle";
import ContactForm from "../components/ContactForm";
import ProtocolExplained from "../components/ProtocolExplained";
import Methodology from "../components/Methodology";
import IndicationsList from "../components/IndicationsList";
import TeamComposition from "../components/TeamComposition";
import LegalDisclaimer from "../components/LegalDisclaimer";
import PricingCard from "../components/PricingCard";
import { useLang } from "../context/LangContext";
import { TREATMENTS } from "../lib/content";

const HEADER = {
  fr: {
    title: "L'exclusivité du protocole. L'exigence du résultat.",
    subtitle: "Le protocole signature exclusif XP & Riviera combine 7 stimulations dans une séance individuelle d'1 heure. Notre équipe se déplace avec ses équipements sur votre lieu de vie ou de séjour — yacht, villa, hôtel, club ou événement privé.",
  },
  en: {
    title: "Exclusive protocol. Uncompromising results.",
    subtitle: "The exclusive signature XP & Riviera protocol combines 7 stimulations in a 1-hour individual session. Our team travels with its equipment to your location — yacht, villa, hotel, club or private event.",
  },
  it: {
    title: "L'esclusività del protocollo. Il rigore del risultato.",
    subtitle: "L'esclusivo protocollo signature XP & Riviera combina 7 stimolazioni in una sessione individuale di 1 ora. Il nostro team si sposta con le proprie attrezzature sul vostro luogo di vita o soggiorno — yacht, villa, hotel, club o evento privato.",
  },
  ru: {
    title: "Эксклюзивность протокола. Безупречность результата.",
    subtitle: "Эксклюзивный фирменный протокол XP & Riviera сочетает 7 стимуляций в индивидуальном сеансе длительностью 1 час. Наша команда приезжает со своим оборудованием туда, где вы живёте или отдыхаете — яхта, вилла, отель, клуб или частное мероприятие.",
  },
};

export default function Treatments() {
  const { lang } = useLang();
  const h = HEADER[lang] || HEADER.en;
  return (
    <main className="pt-32" data-testid="page-treatments">
      <section className="container-luxe py-16">
        <SectionTitle
          eyebrow={lang === "fr" ? "CATALOGUE OFFICIEL · SAISON 2026" : lang === "it" ? "CATALOGO UFFICIALE · STAGIONE 2026" : lang === "ru" ? "ОФИЦИАЛЬНЫЙ КАТАЛОГ · СЕЗОН 2026" : "OFFICIAL CATALOGUE · 2026 SEASON"}
          title={h.title}
          subtitle={h.subtitle}
        />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px hairline">
          {TREATMENTS.map((item, i) => (
            <PricingCard key={item.key} item={item} index={i} />
          ))}
        </div>
        <p className="mt-6 text-[11px] uppercase tracking-[0.2em] text-[var(--ink)]/40 font-display">
          {lang === "fr" ? "TVA et éventuels frais précisés sur devis · Sous réserve de modifications" : "VAT and additional fees detailed on quote · Subject to change"}
        </p>
      </section>
      <TeamComposition />
      <ProtocolExplained />
      <Methodology />
      <IndicationsList />
      <section className="container-luxe pb-16">
        <ContactForm source="treatments" />
      </section>
      <LegalDisclaimer />
    </main>
  );
}
